/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Auth
 */
export interface Auth {
    /**
     * uuid
     * @type {string}
     * @memberof Auth
     */
    uuid: string;
    /**
     * Username
     * @type {string}
     * @memberof Auth
     */
    username: string;
}

/**
 * Check if a given object implements the Auth interface.
 */
export function instanceOfAuth(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "uuid" in value;
    isInstance = isInstance && "username" in value;

    return isInstance;
}

export function AuthFromJSON(json: any): Auth {
    return AuthFromJSONTyped(json, false);
}

export function AuthFromJSONTyped(json: any, ignoreDiscriminator: boolean): Auth {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'uuid': json['uuid'],
        'username': json['username'],
    };
}

export function AuthToJSON(value?: Auth | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'uuid': value.uuid,
        'username': value.username,
    };
}

